import { CircularProgress, Modal } from "@mui/material";
import styled from "styled-components";

const LoadingComponent = styled.div`
/* HTML: <div class="loader"></div> */
&.loader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 8px solid #8FECEA33;
    border-right-color: #FBE250;
    animation: l2 1s infinite linear;
}

&:focus-visible {
    outline: none;
}

@keyframes l2 {to{transform: rotate(1turn)}}
`;

function LoadingModal({
    open,
}) {
    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <LoadingComponent className="loader"/>
        </Modal>
    )
}

export default LoadingModal;